var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header-helper',{attrs:{"id":"past-months"}},[_vm._v("Past 3 Months Gross Revenue and Potential")])}
var staticRenderFns = []

export { render, staticRenderFns }